var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphTypeAreaWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.24783702,2.66459478 L5.627,12.836 L1.2857406,17.2671128 C1.10258448,17.4540317 1,17.7053006 1,17.9669966 L1,19.9999954 C1.00369677,21.1078945 1.90211009,22.0003322 3.00667344,21.9966579 L21.0066734,21.9365853 C22.1086316,21.9329083 23,21.0385606 23,19.9365964 L23,11.9999954 C23,11.7234925 22.8855104,11.4593266 22.6837343,11.2702689 L18.9294756,7.75265048 L18.8353396,7.67453284 C18.4127765,7.36513338 17.811181,7.43341425 17.4711045,7.84997515 L14.555,11.421 L11.1213029,2.63598206 C10.784424,1.77402913 9.55823644,1.79275621 9.24783702,2.66459478 Z M10.233,5.858 L13.3155583,13.7445327 L13.3679545,13.8580825 C13.6975644,14.4715728 14.5644666,14.5728495 15.021587,14.0129212 L18.343,9.943 L21,12.433 L21,19.9365964 L3,19.9966577 L2.999,18.375 L7.20841076,14.0803959 C7.30986954,13.9768527 7.38760305,13.8524885 7.43622531,13.71592 L10.233,5.858 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphTypeAreaWhite);
export default __webpack_public_path__ + "static/media/graph_type_area_white.07876169.svg";
export { ForwardRef as ReactComponent };